import React, { useState } from 'react';
import { UnfoldMore } from '@mui/icons-material';
import { UnfoldLayout } from '../../types/portfolio';

interface CenteredUnfoldIconProps {
  layout: UnfoldLayout;
  onExpand: () => void;
  pageWidth: number;
  isVisible: boolean;
}

/**
 * Centered unfold icon component
 * Displays an icon between left and right unfoldable pages with an always-visible layout badge
 */
export const CenteredUnfoldIcon: React.FC<CenteredUnfoldIconProps> = ({
  layout,
  onExpand,
  pageWidth,
  isVisible
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onExpand();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      onExpand();
    }
  };

  if (!isVisible) return null;

  return (
    <div
      className="absolute top-1/2 z-10 pointer-events-none"
      style={{
        left: `${pageWidth}px`,
        transform: 'translateY(-50%)'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Centered unfold icon */}
      <div
        className="bg-blue-500 rounded-full p-3 shadow-lg cursor-pointer pointer-events-auto transition-all duration-200 unfold-arrow-pulsate"
        onClick={handleIconClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-label={`Expand to view ${layout} layout with all pages`}
        style={{
          transform: `translateX(-50%) scale(${isHovered ? 1 : 0.75})`
        }}
      >
        <UnfoldMore className="w-6 h-6 text-white" />
      </div>
    </div>
  );
};
